import React, { useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle, Nav, NavLink } from 'reactstrap'
import { BsCheckCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../assets/utils/images/svgs/Cross.svg";
import 'tippy.js/themes/light.css';
import { iconSwitch } from 'Components/IconDropdown/Cross_Tick/utils';

const GroupStatus = ({ iconChangeHandler, field, data}) => {
    const [isOpen, setOpen] = useState(false);
    const handleSelect = (d) => {
        iconChangeHandler(field, d);
        setOpen(false);
    };
    return (
        <div className='d-flex'>
            <ButtonDropdown isOpen={isOpen} toggle={() => setOpen(!isOpen)} className='svg-n-size'>
                <DropdownToggle color="link" className="p-0 d-flex" onClick={() => setOpen(!isOpen)} >
                    {iconSwitch(parseInt(data))}
                </DropdownToggle>
                {isOpen &&
                    <DropdownMenu end className="rm-pointers dropdown-menu-lg groupStatus-dropdown-width">
                        <Nav vertical className="dropdown-custom-link">
                            <NavLink className="link-gap" href="#" onClick={() => {
                                handleSelect(1)
                            }}>
                                <BsCheckCircle color='#39A825' className='svg-n-size' />
                            </NavLink>

                            <NavLink className="link-gap" href="#" onClick={() => {
                                handleSelect(0);
                            }}>
                                <CrossIcon className='svg-n-size' />
                            </NavLink>
                        </Nav>
                    </DropdownMenu>
                }
            </ButtonDropdown>
        </div>
    )
}

export default GroupStatus